export default {
  addKeyModal: {
    action: 'Toepassen',
    errorMessage:
      'Fout bij toepassing van sleutel. Als het probleem aanhoudt, neem dan contact op met het Metrica Sports support-team',
    minutesMessage: 'Je sleutel is verwerkt. Je hebt nu %{minutes} minuten beschikbaar.',
    placeholder: 'Typ een sleutel...',
    successMessage: 'Sleutel is succesvol verwerkt',
    title: 'Voeg een Sleutel toe'
  },
  admin: {
    NoGames: 'Geen games, voeg je eerste toe...',
    NoResults: 'Geen Resultaten...',
    addKey: 'Sleutel toevoegen',
    atd: 'ATD',
    automatedTrackingData: 'Automatische Trackingdata (ATD)',
    automatedTrackingDataJobSuccess:
      'Het geautomatiseerde Tracking Data-proces op %{vpName} is voltooid en is nu beschikbaar in Metrica PlayBase',
    automatedTrackingDataProcessedTooltip: 'Automatische Trackingdata verwerkt',
    awayTeam: 'Uitploeg',
    awayTeamScore: 'Score Uitploeg',
    ballDetection: 'Baldetectie',
    ballTracking: 'Baltracking',
    ballTrackingProcessedTooltip: 'Baldetectie verwerkt',
    ballTrackingTooltip:
      'Dit proces zal de bal detecteren en stelt je in staat om deze te visualiseren binnen de Live Formatie (2D Pitch) in PlayBase. De coördinaten van de bal zullen ook beschikbaar zijn in het FIFA EPTS-formaat bestand.',
    cancelATDProcessSuccessfully: 'Automatische Trackingdata is geannuleerd op %{vpName}',
    cancelDataIntegrationProcessSuccessfully: 'Data-integratieproces is geannuleerd op %{vpName}',
    cancelEventsProcessSuccessfully: 'Het Smart Tagging-proces is geannuleerd op %{vpName}.',
    cancelProcessTooltip: 'Proces annuleren',
    cancelSurfacesProcessSuccessfully: 'Oppervlakken-proces is geannuleerd op %{vpName}',
    cancelTrackingFifaFormatProcessSuccessfully:
      'Verwerken van Tracking FIFA-indeling is geannuleerd op %{vpName}',
    category: 'Categorie',
    checking: 'Bezig met controleren...',
    cloudMinutes: 'GameCloud Minuten',
    competition: 'Competitie',
    connectionFailed: 'Verbinding mislukt',
    connectionFailedText:
      'Er lijkt een probleem te zijn met het ophalen van de statusinformatie. Controleer je internetverbinding en laad de pagina opnieuw. Als het probleem aanhoudt, neem dan contact op met support',
    correctedTracking: 'Verwerking Trackingcorrectie',
    correctionUsage: 'Ga je dit Video Project gebruiken voor Trackingcorrectie?',
    correctionUsageTooltip:
      "Tracking Correction Manager (TCM) is een gebruikersgerichte module binnen PlayBase om tracks die eerder zijn gegenereerd met onze ATD te corrigeren, die automatisch gegevens zonder ID's genereert voor elke voetbalwedstrijd. Gebruik TCM om verkeerde tracks te corrigeren en ze een identiteit toe te wijzen. Neem contact met ons op voor meer informatie.",
    createVideoProject: 'Video Project maken',
    creatingGame: 'Video Project aan het maken...',
    dataIntegrationFailed:
      'Data-integratie is mislukt op %{vpName}. Ga naar het Data-integratiepaneel, controleer je bestanden en probeer het opnieuw. Als de fout zich blijft voordoen, neem dan contact op met het Metrica Sports support-team',
    dataIntegrationJobSuccess: 'Data-integratieproces voor %{vpName} is met succes voltooid',
    date: 'Datum',
    description: 'Omschrijving',
    editedSuccessfully: '%{vpName} is succesvol bewerkt',
    errorContactSupport: 'Fout. Neem contact op met support',
    errorProcessTooltip: 'Fout bij proces',
    eventsDetection: 'Automatische Tagging',
    eventsDetectionProcessedTooltip: 'Smart Tagging verwerkt',
    eventsDetectionTooltip: {
      footer: "*Beschikbaar voor video's langer dan 30 minuten.",
      header:
        'Maak gebruik van onze technologie om automatisch een reeks gebeurtenissen te detecteren die zich voordoen in de wedstrijd*:'
    },
    fieldRecognition: 'Velddetectie',
    fieldTrackingProcessedTooltip: 'Velddetectie verwerkt',
    fieldTrackingTooltip:
      'Verwerk Veld Detectie om visualisaties toe te voegen met snelheids- en afstandswaarden en alle tekeningen afhankelijk van het veld in PlayBase.',
    fileDeletedSuccessfully: '%{fileName} succesvol verwijderd voor %{vpName}',
    fileUploadedError: 'Fout bij uploaden van %{fileName} voor %{vpName}',
    fileUploadedSuccessfully: '%{fileName} is succesvol geüpload voor %{vpName}',
    forkedGameLimit:
      'Dit Video Project is van een andere Organisatie, dus het is niet mogelijk om deze te wijzigen',
    gameDeletedSuccessfully: '%{game} succesvol verwijderd',
    gameVideoProject: 'Wedstrijd-Video Project',
    getMoreMinutes: 'Neem er meer',
    homeTeam: 'Thuisploeg',
    homeTeamScore: 'Score Thuisploeg',
    initializing: 'Initialiseren...',
    jobFailed:
      'Het %{process}-proces is mislukt voor %{vpName}. Neem contact op met het Metrica Sports support-team',
    liveCoding: 'of doorgaan voor live coding?',
    liveCodingTooltip:
      'Je kunt een Video Project maken zonder een videobestand te selecteren, voor Live Coding-doeleinden. Zodra je de video hebt, kun je deze toevoegen om Automatische Trackingdata te krijgen binnen het gecodeerde Video Project.',
    localTeamOnTheLeft:
      "Bevindt de 'Thuisploeg' zich aan de linkerkant van het veld in de eerste helft?",
    localTeamOnTheLeftTooltip:
      'Om Automatische Tagging te verwerken, specificeer aan welke kant van het veld elk team zich bevindt. Bekijk de video die je uploadt om dit te valideren.',
    minutes: '%{minutes} Minuten',
    noFootballSideViewTooltip:
      'Dit Video Project bevat een videobestand van een niet-voetbal groothoek- of tv-uitzending, dus alleen Speler- en Teamdetectie is verwerkt.',
    noMatches: 'Geen Overeenkomsten...',
    noSubscriptionOwnerTooltip:
      "Neem contact op met '%{email}', de beheerder van jouw abonnement, om te upgraden, of ga naar onze Plannenpagina om je eigen abonnement aan te maken",
    noVideoFile: 'Geen videobestand',
    notPossibleToDeleteThisEntry: 'Dit item kan niet worden verwijderd',
    numberOfHalves: 'Hoeveel helften worden gedurende deze wedstrijd gespeeld?',
    numberOfHalvesTooltip:
      'Om Automatische Tagging te verwerken, specificeer hoeveel spelperiodes de video die je uploadt bevat.',
    oldAtdTooltip: 'Deze video is verwerkt met een oudere versie van ATD',
    onRequest: 'Op verzoek',
    organizations: 'Organisaties',
    place: 'Locatie',
    playerTracking: 'Speler- & Teamdetectie',
    playerTrackingProcessedTooltip: 'Spelerdetectie verwerkt',
    playerTrackingTooltip:
      'Dit proces zal de doelmannen en de 10 veldspelers van elk team detecteren. Dit zal je toelaten om de Live Formatie (2D Pitch) te visualiseren en Speler Visualisaties automatisch toe te voegen in PlayBase. De coördinaten van de spelers zullen ook beschikbaar zijn in het FIFA EPTS formaat bestand.',
    postProcessingData: 'Nabewerking van data...',
    preProcessingAtd: 'Voorbewerking...',
    processingTooltip: 'Wordt verwerkt…',
    readyToUpload: 'Klaar om te uploaden',
    search: 'Zoeken…',
    selectVideoFile: 'Selecteer videobestand',
    settingUpAtd: 'Detectie aan het opstarten',
    settings: 'Instellingen',
    singleVideoProject: 'Enkel-Video Project',
    startAtd: 'ATD starten',
    startFifaMessage:
      'FIFA-integratieproces voor %{vpName} is gestart. We geven een melding weer als het klaar is. Even geduld aub.',
    startProcessingWaitingJobsFailed: 'Het verzenden van wachtende taken is mislukt',
    startProcessingWaitingJobsSuccessfully: 'Wachtende taken zijn succesvol verzonden',
    startSsMessage:
      'Second Spectrum-integratieproces voor %{vpName} is gestart. We geven een melding weer als het klaar is. Even geduld aub.',
    startStatsMessage:
      'Stats-integratieproces voor %{vpName} is gestart. We geven een melding weer als het klaar is. Even geduld aub.',
    startTracabDflMessage:
      'Tracab DFL-integratieproces voor %{vpName} is gestart. We geven een melding weer als het klaar is. Even geduld aub.',
    startTracabMessage:
      'Tracab-integratieproces voor %{vpName} is gestart. We geven een melding weer als het klaar is. Even geduld aub.',
    surfacesJobSuccess: '%{vpName} Oppervlakkenproces is met succes voltooid',
    trackingCorrectionProcessedTooltip: 'Trackingcorrectie is verwerkt',
    trackingFifaFormatJobSuccess:
      'Verwerken van Tracking FIFA-indeling voor %{vpName} is voltooid. Je kunt het bestand nu downloaden door op het menu-item FIFA EPTS-indeling downloaden te klikken',
    trackingLicence: 'Je hebt geen Trackinglicentie',
    uncaughtErrorRow:
      'Fout in Video Project. Gelieve deze pagina te verversen. Als het probleem aanhoudt, neem dan contact op met support of verwijder het Video Project en maak deze opnieuw aan',
    updatingGame: 'Video Project aan het updaten...',
    upgradePlan: 'Upgraden',
    uploadAndTracking: 'Uploaden & Tracken',
    uploadingVideoFile: 'Videobestand aan het uploaden',
    videoFile: 'Videobestand',
    videoFootballSideView:
      'Is dit een videobestand van een groothoek- of tv-uitzending voor voetbal?',
    videoFootballSideViewTooltip: "Velddetectie is alleen geoptimaliseerd voor dit soort video's",
    videoMultipartStart:
      '%{videoName} wordt geüpload op %{vpName}. SLUIT DEZE PAGINA NIET totdat het uploaden is voltooid',
    videoPlaylist: 'Is dit videobestand een afspeellijst?',
    videoPlaylistTooltip:
      'Als je JA selecteert, wordt Clip Detection uitgevoerd om te herkennen wanneer er een knip plaatsvindt in de video, wat het een perfecte tool maakt als je een video uploadt die meerdere clips bevat, bijvoorbeeld. Na het uitvoeren van dit proces, download het Video Project in PlayBase en er zal een Clip Detection Coding bestand zijn met een code die elke knip als een evenement bevat.',
    videoProjectSettings: 'Instellingen Video Project',
    videoUploadError:
      'Video-upload van %{videoName} voor %{vpName} is mislukt. Probeer het opnieuw',
    videoUploaded: '%{videoName} is geüpload op %{vpName}',
    vpCreated: '%{vpName} is aangemaakt',
    waitingAtd: 'Aan het wachten...'
  },
  billing: {
    address: 'Adres',
    billed: 'Gefactureerd',
    completed: 'Betaald',
    details: 'Factuurgegevens',
    history: 'Factureringsgeschiedenis',
    invoiceNotFound: 'Factuur niet gevonden',
    noInvoices: 'Geen facturen',
    past_due: 'Achterstallig',
    taxId: 'Fiscaal Identificatienummer'
  },
  checkout: {
    chargeSubscription: 'In rekening brengen op abonnement',
    costOneTime: '%{currency} %{cost}',
    costRecurrent: '%{currency} %{cost} %{cycle}',
    discountCodes: '*Kortingscodes kunnen worden toegepast bij het afrekenen.',
    dueToday: 'Te betalen vandaag',
    excTax: '(Excl. btw)',
    halfYear: '6 maanden',
    halfYearlyBilled: 'Gefactureerd elke 6 maanden',
    immediatePayment: 'Directe Betaling',
    incTax: '(Incl. btw)',
    month: 'maand',
    monthlyBilled: 'Maandelijks gefactureerd',
    nextPayment: 'Volgende Betaling',
    noPacks: 'Geen GameCloud Minuten',
    onDate: 'op %{date}',
    packs: 'Pakketten',
    packsTotal: 'Totaalpakketten',
    perHalfYear: '/6 maanden',
    perMonth: '/maand',
    perYear: '/jaar',
    plans: 'Abonnementen',
    plansTotal: 'Totaal Plannen',
    proceed: 'Ga door naar betalen',
    subtotal: 'Subtotaal',
    taxPayable: 'Te betalen belasting (%{percentage}%)',
    total: 'Totaal',
    unpaid:
      'Je laatste factuur is nog niet betaald. Gelieve je betalingsinformatie bij te werken om verder te gaan.',
    updatePaymentMethod: 'Betaalmethode bijwerken',
    updateSubscription: 'Abonnement bijwerken',
    upgradeTo: 'Upgraden naar %{plan}',
    userDevice: '1 gebruiker/apparaat',
    usersDevices: '%{number} gebruikers/apparaten',
    year: 'jaar',
    yearlyBilled: 'Jaarlijks gefactureerd'
  },
  common: {
    add: 'Toevoegen',
    back: 'Terug',
    cancel: 'Annuleren',
    canceling: 'Annuleren...',
    clearAll: 'Alles Wissen',
    continue: 'Doorgaan',
    create: 'Creëren',
    deactivate: 'Deactiveren',
    edit: 'Bewerken',
    email: 'E-mail',
    errorMsg: 'Fout bij het verwerken van %{name}. Neem voor vragen contact op met support.',
    errorTryAgain: 'Fout. Probeer het nog eens',
    genericError: 'Fout, proces mislukt. Neem voor vragen contact op met support.',
    loading: 'Bezig met laden...',
    login: 'Inloggen',
    logout: 'Uitloggen',
    new: 'Nieuw',
    next: 'Volgende',
    no: 'Nee',
    noFileChosen: 'Geen bestand gekozen',
    ok: 'OK',
    pending: 'In behandeling',
    required: 'Verplicht',
    reset: 'Wachtwoord herstellen',
    restart: 'Herstarten',
    save: 'Opslaan',
    selectFile: 'Bestand selecteren',
    sort: 'Sorteren',
    start: 'Starten',
    today: 'Vandaag',
    unassigned: 'Niet Toegewezen',
    uploading: 'Bezig met uploaden...',
    yes: 'Ja'
  },
  confirmModal: {
    description: 'Weet je het zeker?',
    title: 'Bevestigen'
  },
  container: {
    download: 'Download Container Bestand',
    notProcessed: 'Het Container-bestand is niet verwerkt in dit Video Project.',
    processed: 'Containerbestand verwerkt',
    title: 'Container',
    titleDownload: 'Download Container'
  },
  dataIntegration: {
    deleteFile: 'Bestand verwijderen',
    featureNotAvailable:
      'Deze functie is niet beschikbaar in je huidige Plan. Je dient te upgraden naar een ander Plan om deze functie te krijgen. Neem contact met ons op voor meer informatie',
    notSideView:
      'Data-integratie is niet beschikbaar voor Video Projecten die een videobestand bevatten van een niet-voetbal groothoek- of tv-uitzending.',
    open: 'Data-integratie openen',
    processJobsFirst:
      'Je dient eerst het verwerken van Automatische Trackingdata (ATD) te starten voordat je het Data-integratiepaneel opent',
    processed: 'Data-integratie verwerkt',
    selectFile: 'Bestand selecteren',
    startProcess: 'Proces starten',
    title: 'Data-integratie',
    waiting: 'Wachten op proces...',
    waitingProcess:
      'Het integratieproces begint zodra de Speler- en Velddetectieprocessen zijn voltooid.'
  },
  deleteModal: {
    checkboxLabel: 'Ik wil ook geen e-mails meer ontvangen van Metrica Sports',
    confirmationType: 'Typ %{validateFormKey} om te bevestigen:',
    deleteAction: 'Ja, Verwijderen',
    description: 'Weet je zeker dat je je account definitief wilt verwijderen?',
    information:
      'Je verliest alle Video Projecten die met dit account zijn gemaakt. We kunnen ze niet meer herstellen nadat ze zijn verwijderd.',
    keepAccount: 'Account behouden',
    suggestion: 'We raden je aan om je account te behouden.',
    title: 'Voor eeuwig verwijderen?',
    validateFormKey: 'VERWIJDEREN'
  },
  error: {
    oops: 'Oeps!',
    restart:
      'Het lijkt erop dat je ergens in probeert te komen wat we nog aan het ontwikkelen zijn...'
  },
  eventsDetection: {
    automaticVp: 'Smart Tagging niet beschikbaar op Videoprojecten met een oudere ATD-versie.',
    download: 'Download Smart Tagging evenementen in XML-formaat',
    needsAtd: 'Start eerst het ATD-proces om het Smart Tagging-proces uit te kunnen voeren.',
    needsFootballSideView:
      'Smart Tagging niet beschikbaar op Videoprojecten die een videobestand bevatten dat geen voetbal is vanuit een breedhoek of tv-uitzending.',
    needsGameVp: 'Smart Tagging is alleen beschikbaar bij Game Video Projecten.',
    needsNoPlaylist:
      'Smart Tagging niet beschikbaar op Videoprojecten die een afspeellijst videobestand bevatten.'
  },
  forgotPassword: {
    adminNoResetPassword:
      'Admin-gebruikers dienen een privé endpoint te gebruiken om wachtwoord te resetten',
    notFound: 'Gebruiker niet gevonden. Probeer het opnieuw met een geldig e-mailadres',
    success: 'Wachtwoord is gereset! Check je e-mail'
  },
  groups: {
    addMembers: 'Leden Toevoegen',
    addOrUpdateErrorMessage:
      'Fout bij het verwerken van de groep. Als het probleem aanhoudt, neem contact op met het ondersteuningsteam van Metrica Sports',
    availableMinutes: 'Beschikbare Minuten',
    availableMinutesWarning:
      'Je hebt %{availableMinutes} minuten om toe te wijzen aan een organisatie',
    createGroup: 'Groep Aanmaken',
    deleteErrorMessage:
      'Fout bij het verwijderen van de groep. Als het probleem aanhoudt, neem contact op met het ondersteuningsteam van Metrica Sports',
    deleteGroup: 'Groep Verwijderen',
    deleteGroupDescription:
      'Je probeert de groep %{pre}%{name}%{post} te verwijderen. Als er een Video Project gekoppeld is aan deze groep, zullen gebruikers er niet meer toegang toe hebben.',
    deleteNow: 'Verwijder nu',
    deleteThisGroup: 'Verwijder deze groep',
    editGroup: 'Groep Bewerken',
    enterEmails: 'Voer de e-mails van de gebruikers in die je wilt toevoegen',
    enterGroupName: 'Voer de groepsnaam in',
    enterValidName: 'Voer alstublieft een geldige naam in',
    gameCloudMinutes: 'GameCloud Minuten',
    groupMembers: 'Leden van de groep',
    groupName: 'Groepsnaam',
    manageGameCloudMinutes: 'Beheer GameCloud Minuten',
    minutesErrorMessage:
      'Fout bij het beheren van de minuten. Als het probleem aanhoudt, neem contact op met het ondersteuningsteam van Metrica Sports',
    moreLicensesDescription:
      'Om gelicentieerde gebruikers aan je account toe te voegen, koop alsjeblieft meer licenties',
    name: 'Groepsnaam',
    noMultiLicenseDescription: 'Alleen multi-license plannen mogen groepen creëren',
    noPermissionDescription:
      'Je gebruiker behoort tot de organisatie %{pre}%{ownerEmail}%{post}, neem contact op met de eigenaar om te upgraden of wijzigingen uit te voeren'
  },
  login: {
    clickHere: 'Klik hier',
    contactUs: 'Neem contact met ons op',
    dontHaveAccount: 'Ik heb geen account. %{pre}Meld Je Aan%{post}',
    enterYourEmail: 'Vul je e-mailadres in',
    enterYourPassword: 'Voer je wachtwoord in',
    forgotPassword: 'Ik ben mijn wachtwoord vergeten. %{pre}Klik Hier%{post}',
    invalidEmail: 'Ongeldig e-mailadres',
    licenceExpired: 'Je licentie is verlopen.',
    trialExpired: 'Je proeflicentie is verlopen.',
    upgradePlan: 'Upgrade jouw Plan'
  },
  patterns: {
    delete: 'Patroonbestand verwijderen',
    title: 'Aangepaste Patronenbestand',
    upload: 'Aangepaste Patronenbestand uploaden',
    uploaded: 'Patroonbestand geüpload',
    uploading: 'Patroonbestand aan het uploaden'
  },
  plans: {
    academic: 'Academisch',
    addMoreProducts: '+ Meer producten toevoegen',
    admin: 'Admin',
    basic: 'Basic',
    basicCodePadMonthly: 'Basic+Code Maandelijks',
    basicCodePadYearly: 'Basic+Code Jaarlijks',
    basicMftCodePadMonthly: 'Full Basic Maandelijks',
    basicMftCodePadYearly: 'Full Basic Jaarlijks',
    basicMftMonthly: 'Basic+MFT Maandelijks',
    basicMftXmlMonthly: 'Basic MFT + XML Maandelijks',
    basicMftXmlYearly: 'Basic MFT + XML Jaarlijks',
    basicMftYearly: 'Basic+MFT Jaarlijks',
    basicMonthly: 'Basic Maandelijks',
    basicXmlMonthly: 'Basic XML Maandelijks',
    basicXmlYearly: 'Basic XML Jaarlijks',
    basicYearly: 'Basic Jaarlijks',
    code: 'Code',
    elite: 'Elite',
    elite2024Yearly: 'Elite Jaarlijks',
    eliteYearly: 'Elite Jaarlijks',
    essentialsCodeMonthly: 'Essentials + Code ∞ Maandelijks',
    essentialsCodeYearly: 'Essentials + Code ∞ Jaarlijks',
    essentialsMftCodeMonthly: 'Volledige Essentials Maandelijks',
    essentialsMftCodeYearly: 'Volledige Essentials Jaarlijks',
    essentialsMftMonthly: 'Essentials + MFT Maandelijks',
    essentialsMftYearly: 'Essentials + MFT Jaarlijks',
    essentialsMonthly: 'Essentials Maandelijks',
    essentialsYearly: 'Essentials Jaarlijks',
    influencer: 'Influencer',
    lite: 'Lite',
    liteMonthly: 'Lite Maandelijks',
    liteYearly: 'Lite Jaarlijks',
    minutes10: '10 GameCloud Minuten',
    minutes100: '100 GameCloud Minuten',
    minutes1000: '1.000 GameCloud Minuten',
    minutes10000: '10.000 GameCloud Minuten',
    plan: '%{planName}-Plan',
    planHalfYearly: '%{planName} Halfjaarlijks Plan',
    planMonthly: '%{planName} Maandelijks Plan',
    planYearly: '%{planName} Jaarlijks Plan',
    primeLiveMonthly: 'Prime + Live Maandelijks',
    primeLiveYearly: 'Prime + Live Jaarlijks',
    primeMftLiveMonthly: 'Prime + MFT + Live Maandelijks',
    primeMftLiveYearly: 'Prime + MFT + Live Jaarlijks',
    primeMftMonthly: 'Prime + MFT Maandelijks',
    primeMftYearly: 'Prime + MFT Jaarlijks',
    primeMonthly: 'Prime Maandelijks',
    primePresetsLiveMonthly: 'Prime + Presets + Live Maandelijks',
    primePresetsLiveYearly: 'Prime + Presets + Live Jaarlijks',
    primePresetsMftLiveMonthly: 'Full Prime Maandelijks',
    primePresetsMftLiveYearly: 'Full Prime Jaarlijks',
    primePresetsMftMonthly: 'Prime + Presets + MFT Maandelijks',
    primePresetsMftYearly: 'Prime + Presets + MFT Jaarlijks',
    primePresetsMonthly: 'Prime + Presets Maandelijks',
    primePresetsYearly: 'Prime + Presets Jaarlijks',
    primeYearly: 'Prime Jaarlijks',
    pro: 'Pro',
    pro2024LiveMonthly: 'Pro + Live Maandelijks',
    pro2024LiveYearly: 'Pro + Live Jaarlijks',
    pro2024Monthly: 'Pro Maandelijks',
    pro2024Yearly: 'Pro Jaarlijks',
    proYearly: 'Pro Jaarlijks',
    starter: 'Starter',
    starterCodeMonthly: 'Starter + Code ∞ Maandelijks',
    starterCodePadMonthly: 'Code Maandelijks',
    starterCodePauseMonthly: 'Volledige Starter Maandelijks',
    starterCodePauseYearly: 'Full Starter Jaarlijks',
    starterCodeYearly: 'Starter + Code ∞ Jaarlijks',
    starterPauseMonthly: 'Starter + Pause ∞ Maandelijks',
    starterPauseYearly: 'Starter + Pause ∞ Jaarlijks',
    student: 'Student',
    trial: 'Proefversie'
  },
  playlist: {
    download: 'Afspeellijstbestand downloaden',
    notProcessed: 'Afspeellijstbestand is niet verwerkt in dit Video Project.',
    processed: 'Afspeellijstbestand is verwerkt',
    title: 'Afspeellijst',
    titleDownload: 'Afspeellijst downloaden'
  },
  products: {
    addOns: 'Add-ons',
    basic: 'Onbeperkte Codes & Aantekeningen',
    code: 'CodePad',
    elite: {
      description:
        'Automatiseer en personaliseer je volledige analyseworkflow. Dit plan biedt volledige toegang tot PlayBase met alle functies van het "Full Essentials" Plan en toegang tot Metrica Nexus met alle functies van het "Pro" Plan.',
      feature1: '✓ Gedeelde Cloud Opslag',
      feature2: '✓ Integratie van Trackinggegevens',
      feature3: '✓ Tracking Correction Manager',
      feature4: '✓ RESTful API'
    },
    essentials: {
      addon1: 'Onbeperkte Coding-functies (CodePad, Live Coding en XML-import)',
      addon2: 'Handmatige Veldtracking',
      essentialsCodeDescription:
        'Dit plan maakt Dynamische Telestratie beschikbaar om onbeperkte bewegingsvisualisaties toe te voegen tijdens het afspelen van de video en in pauzes. Dit plan bevat geen Handmatige Veldtracking, dus visualisaties van Snelheid en Afstand zijn niet inbegrepen. Het ontgrendelt ook de beperking van coding-functies zoals CodePad, Live Coding en XML-import en heft de limiet van 4 codes per Videoproject op naar onbeperkte codes.',
      essentialsDescription:
        'Dit plan maakt Dynamische Telestratie beschikbaar om onbeperkte bewegingsvisualisaties toe te voegen tijdens het afspelen van de video en in pauzes. Dit plan bevat geen Handmatige Veldtracking, dus visualisaties van Snelheid en Afstand zijn niet inbegrepen. De coding-functies blijven beperkt.',
      essentialsMftCodeDescription:
        'Dit plan maakt Dynamische Telestratie beschikbaar om onbeperkte bewegingsvisualisaties toe te voegen tijdens het afspelen van de video en in pauzes, en activeert ook Manuel Field Tracking om snelheids- en afstandsvisualisaties toe te voegen. Het ontgrendelt ook de beperking van coding-functies zoals CodePad, Live Coding en XML-import en heft de limiet van 4 codes per Video Project op naar onbeperkte codes.',
      essentialsMftDescription:
        'Dit abonnement maakt Dynamische Telestratie beschikbaar om onbeperkte bewegingsvisualisaties toe te voegen tijdens het afspelen van de video en in pauzes, en activeert ook Manuel Field Tracking om snelheids- en afstandsvisualisaties toe te voegen. De coding-functies blijven beperkt.',
      feature1: '✓ Post-game codering (Code Table met maximaal 4 codes)',
      feature2: '✓ Onbeperkte telestratie tijdens pauzes',
      feature3: '✓ Dynamische Telestratie'
    },
    featuresIncluded: 'Inbegrepen functies:',
    freeFeature1: '✓ Post-wedstrijd coding (Code Table met tot 4 codes)',
    freeFeature2: '✓ Handmatige tracking',
    freeFeature3: '✓ Telestratie (tot 50 annotaties)',
    freeFeature4: '✓ Video-exporteren',
    freeFeatures: 'Gratis Functies',
    fullBasic: 'Handmatige Veldtracking',
    lite: 'Automatische Speler- & Veldtracking',
    liteDescription:
      'Geavanceerde coding & geavanceerde visualisaties. Alles automatisch, waardoor het 3x sneller is dan Full Basic!',
    minutesDescription:
      'Vul elk plan aan. Krijg minutenpakketten voor Geautomatiseerde Tracking Data.',
    minutesPack: 'GameCloud Minutenpakket',
    nexus_elite: {
      description: 'Voor de beste teams ter wereld',
      feature1: '✓ Alle Pro Functies',
      feature2: '✓ Volledige Clip Tracking',
      feature3: '✓ Nexus Live (Live Capture + Nexus Mobile)'
    },
    nexus_prime: {
      addon1: 'Nexus Live (Live Capture + Nexus Mobile)',
      description: 'Instapniveau oplossing',
      feature1: '✓ Volledige Game Analysis',
      feature2: '✓ Volledige Telestration',
      feature3: '✓ Handmatige Tracking'
    },
    nexus_pro: {
      addon1: 'Nexus Live (Live Capture + Nexus Mobile)',
      description: 'Automatiseer je workflow',
      feature1: '✓ Volledige Game Analyse',
      feature2: '✓ Volledige Telestration',
      feature3: '✓ Automatische Tracking'
    },
    otherDescription: 'Geavanceerde coding-functies met basis telestratie en beperkte annotaties.',
    playbase_advanced: {
      description: 'Volledig geautomatiseerde analyse',
      feature1: '✓ Volledige Game Analyse',
      feature2: '✓ Telestration in Beweging',
      feature3: '✓ Automatische Tracking'
    },
    playbase_essentials: {
      description: 'Instapniveau Oplossing',
      feature1: '✓ Volledige Game Analysis',
      feature2: '✓ Telestration op Pauzes'
    },
    playbase_plus: {
      description: 'Doe Tracking op je eigen tempo',
      feature1: '✓ Volledige Game Analyse',
      feature2: '✓ Telestration in Beweging',
      feature3: '✓ Handmatige Tracking'
    },
    prime: {
      addon1: 'Handmatige Veldtracking',
      addon2: 'Aangepaste Telestratie (pas je eigen visualisaties aan en sla ze op)',
      addon3: 'Live Opname (Capture, Analyseer en Deel Highlights Onderweg)',
      feature1: '✓ Volledige toegang tot PlayBase met alle functies van het "Full Essentials" Plan',
      feature2: '✓ Toegang tot Metrica Nexus met:',
      feature2_1: 'Sequentiële Pauzes',
      feature2_2: 'Geavanceerde Telestratie',
      feature2_3: 'Aangepaste video-export',
      primeDescription:
        'Dit plan omvat volledige toegang tot PlayBase met alle functies van het "Essentials + Code ∞" Plan en maakt Metrica Nexus mogelijk met geavanceerde telestratie.',
      primeMftDescription:
        'Dit plan biedt volledige toegang tot PlayBase met alle functies van het "Full Essentials" Plan en maakt Metrica Nexus mogelijk met geavanceerde telestratie.',
      primePresetsDescription:
        'Dit plan biedt volledige toegang tot PlayBase met alle functies van het "Essentials + Code ∞" Plan en maakt Metrica Nexus mogelijk met geavanceerde telestratie en aangepaste visualisaties.',
      primePresetsMftDescription:
        'Dit plan biedt volledige toegang tot PlayBase met alle functies van het "Full Essentials" Plan en stelt Metrica Nexus in staat met geavanceerde telestratie en aangepaste visualisaties.'
    },
    pro: {
      addon1: 'Live Opname (Capture, Analyseer en Deel Hoogtepunten Onderweg)',
      description:
        'Dit plan omvat volledige toegang tot PlayBase met alle functies van het "Full Essentials" Plan en toegang tot Metrica Nexus met alle functies van het "Full Prime" Plan.',
      feature1: '✓ Automatische Speler Tracking',
      feature2: '✓ Automatische Veldtracking',
      feature3: '✓ Volledige toegang tot PlayBase met alle functies van het "Full Essentials" Plan',
      feature4: '✓ Toegang tot Metrica Nexus met:',
      feature4_1: 'Sequentiële pauzes',
      feature4_2: 'Geavanceerde Telestratie',
      feature4_3: 'Aangepaste video-export',
      feature4_4: 'Aangepaste Visualisaties (pas aan en bewaar je eigen visualisaties)'
    },
    remove: 'Verwijderen',
    starter: {
      addon1: 'Onbeperkte telestratie tijdens pauzes',
      addon2: 'Onbeperkte Coding-functies (CodePad, Live Coding en XML-import)',
      feature1: '✓ Post-wedstrijd codering (Code Table met maximaal 4 codes)',
      feature2: '✓ Telestratie tijdens pauzes (tot 50 annotaties per maand)',
      feature3: '✓ Video-export',
      starterCodeDescription:
        'Dit plan ontgrendelt de beperking van coding-functies zoals CodePad, Live Coding en XML-import. Het heft ook de limiet van 4 codes per Videoproject op naar onbeperkte codes. De beperkingen in de functies voor telestratie blijven bestaan bij Free Starter.',
      starterCodePauseDescription:
        'Dit abonnement heft de beperking van coding-functies op zoals CodePad, Live Coding en XML-import. Het verwijdert ook de limiet van 4 codes per Videoproject naar onbeperkte codes, en heft de beperking van telestratie in pauzes op van 50 per maand naar onbeperkt.',
      starterPauseDescription:
        'Dit plan heft de beperking van telestratie in pauzes op van 50 per maand naar onbeperkt. De beperkingen in de coding-functies blijven bestaan in Free Starter.'
    },
    totalPack: '%{currency} %{cost}'
  },
  settings: {
    billing: 'Facturering',
    billingSettings: 'Factureringsinstellingen',
    billingSettingsDescription: '(wijzig je Plan, update betaalmethoden...)',
    cancelAt: 'Je Plan stopt op',
    cancelPlan: 'Plan annuleren',
    confirmNewPassword: 'Bevestig nieuw Wachtwoord',
    deleteAccount: 'Account verwijderen',
    details: 'Mijn gegevens',
    devices: 'Apparaten',
    devicesResetError: 'Fout bij het resetten van de apparaten. Probeer het opnieuw',
    devicesResetSuccess: 'Al je apparaten zijn succesvol gereset',
    emailNotActivated: 'E-mailnotificaties zijn nu geactiveerd',
    emailNotDeactivated: 'E-mailnotificaties zijn nu gedeactiveerd',
    emailNotifications: 'E-mailnotificaties',
    groups: 'Groepen',
    language: 'Taal',
    languageChanged: 'Taal is bijgewerkt',
    manualResetDevices: 'Neem contact op met support om je apparaten te resetten',
    newPassword: 'Nieuw Wachtwoord',
    noDevicesToReset: 'Geen apparaten om te resetten',
    noOwner:
      'Je plan behoort tot de organisatie %{pre}%{email}%{post}, neem contact op met de eigenaar om te upgraden of wijzigingen door te voeren',
    organizationLabel: 'Voorvoegsel Organisatie',
    organizationTooltip:
      'Dit voorvoegsel is nodig voor het importeren van aangepaste patronen naar een Video Project. Neem contact met ons op voor meer informatie of bekijk de documentatie op codeball.metrica-sports.com',
    passwordsDontMatch: 'Wachtwoorden komen niet overeen',
    passwordInvalid: 'Het wachtwoord voldoet niet aan de vereisten',
    passwordRequirements: {
      minLength: 'Minstens %{count} tekens',
      uppercase: 'Eén hoofdletter',
      lowercase: 'Eén kleine letter',
      number: 'Eén cijfer (0-9)',
      maxLength: 'Maximaal %{count} tekens'
    },
    pauseAt: 'Je abonnement wordt gepauzeerd op',
    planCanceled: 'Je plan is geannuleerd. Check je e-mail voor meer informatie',
    plans: 'Abonnementen',
    quantity: 'Hoeveelheid:',
    remainingResets: '%{current}/%{max} resterende switches dit jaar',
    renewAt: 'Je Plan wordt verlengd op',
    resetDeviceAction: 'Apparaten Resetten',
    title: 'Instellingen',
    upgradePlan: 'Plan upgraden',
    userKey: 'Gebruikerssleutel:',
    userKeyUsages: '%{current}/%{max} gebruikt',
    userSettings: 'Gebruikersinstellingen',
    users: 'Gebruikers'
  },
  shoppingCart: {
    subtitle: 'Kies je Metrica Sports plan en add-ons om je prestaties te verhogen.',
    title: 'Stel je Metrica Sports in'
  },
  subscription: {
    cancelSubscription: 'Abonnement opzeggen',
    errorUpdating:
      'Er was een fout bij het bijwerken van je abonnement. Stuur een e-mail naar support@metrica-sports.com en we helpen je graag verder.',
    free: 'Gratis',
    isObsolete:
      'Je abonnement kan niet worden gewijzigd. Vervang verouderde producten door nieuwe om wijzigingen mogelijk te maken',
    pendingRefundRequest:
      'Er kunnen geen verdere wijzigingen aan dit abonnement worden gemaakt zolang er een terugbetalingsverzoek in behandeling is.',
    planMigrationMessage:
      "Vanaf 1 april wordt je <strong>%{currentPlan}</strong> abonnement <strong>%{newPlan}</strong> genoemd, maar er worden geen kosten in rekening gebracht. Je hoeft niets te doen. Op <strong>%{date}</strong> zal de prijs van je abonnement <strong>%{newPrice}</strong> per gebruiker, per <strong>%{cycle}</strong> zijn. Om meer te weten te komen over alle nieuwe abonnementen <a href='%{link}'>klik hier</a>.",
    undoCancel: 'Annulering van abonnement ongedaan maken',
    undoPause: 'Abonnement pauze ongedaan maken',
    updatePaymentMethod: 'Betaalmethode bijwerken',
    updatedSuccessfully: 'Abonnement succesvol bijgewerkt',
    yourPlans: 'Jouw Plannen',
    yourSubscription: 'Jouw Abonnement'
  },
  successfulPayment: {
    addUsers: 'Voeg andere gebruikers toe aan je organisatie.',
    allTheBest: 'Al het beste,',
    applyKey: 'Sleutel toepassen op dit account',
    applyKeyDescription: 'Zou je deze licentie voor je account willen activeren?',
    assignLicenses: 'Transfer je licentie naar een andere account.',
    download:
      'Ga naar de %{pre}Downloads Pagina%{post} op onze website en download PlayBase of Nexus, afhankelijk van je licentie.',
    faq: 'Hier is hoe je snel kunt beginnen, en wat andere relevante info:\nHier heb je hoe je snel kunt starten en andere relevante informatie:',
    happyPlay:
      'We hopen dat alles duidelijk is, maar aarzel niet om contact met ons op te nemen als je nog verdere vragen of twijfels hebt.',
    helpCenter:
      'Neem een kijkje in ons %{pre}Help Center%{post} voor veel nuttige artikelen, zoals volledige tutorials en veelgestelde vragen.',
    howToCancel:
      'Houd er rekening mee dat je abonnement automatisch wordt verlengd totdat het expliciet %{pre}geannuleerd wordt via onze GameCloud-instellingen%{post}, in overeenstemming met onze Algemene Voorwaarden.',
    keyApplied: 'Sleutel toegepast',
    licenseActivation1:
      'Als je nog geen actieve licentie voor je account had, is je nieuw aangeschafte licentie automatisch geactiveerd.',
    licenseActivation2:
      'Als je licentie om welke reden dan ook niet is geactiveerd, kun je deze hieronder activeren:',
    licenseKey: 'Je licentiesleutel is: %{pre}%{licenseKey}%{post}',
    licensesTitle: 'Licentieactivering',
    metricaSportsTeam: '— Het team van Metrica Sports',
    minutesInfo:
      'Als je jouw GameCloud minuten over verschillende gebruikersgroepen wilt verdelen, ga dan naar het tabblad Groepen binnen de %{pre}Instellingen Pagina%{post}.',
    minutesTitle: 'Jouw GameCloud Minuten',
    renewalInfo:
      'Houd er rekening mee dat je abonnement automatisch wordt verlengd totdat het expliciet %{pre}geannuleerd wordt via onze GameCloud-instellingen%{post}, in overeenstemming met onze Algemene Voorwaarden.',
    settingsCloud: 'Bezoek onze %{pre}GameCloud%{post} en navigeer naar het Instellingenmenu om:',
    technicalSupport: 'Voor technische ondersteuning, %{pre}neem direct contact met ons op%{post}.',
    thanks: 'Bedankt voor je bestelling, we hebben deze succesvol verwerkt!',
    title: 'Bestelbevestiging',
    updatePayment: 'Werk je betaalmethode bij.',
    updateSubscription: 'Annuleer of wijzig je abonnement.'
  },
  surfaces: {
    automaticVp:
      'Oppervlakken zijn niet beschikbaar voor Video Projecten met een oudere ATD-versie',
    delete: 'Oppervlakkenbestand verwijderen',
    needsAtd: 'Start eerst het ATD-proces om daarna Oppervlakken-processen uit te voeren',
    needsElite:
      'Aangepaste Oppervlakken zijn beschikbaar bij het Elite-Plan. Neem contact met ons op voor meer informatie',
    needsFootballSideView:
      'Oppervlakken zijn niet beschikbaar voor Video Projecten die een videobestand bevatten van een niet-voetbal groothoek- of tv-uitzending',
    pitchControl:
      'Door dit proces uit te voeren, kun je de visualisatie van Pitch Control toevoegen in PlayBase.',
    pitchControlProcessed: 'Pitch Control-oppervlak verwerkt',
    pitchControlProcessing: 'Pitch Control aan het verwerken',
    processed: 'Oppervlak-bestand geüpload',
    processing: 'Oppervlak-bestand aan het verwerken',
    title: 'Oppervlakken',
    titlePitchControl: 'Pitch Control',
    upload: 'Upload je eigen Oppervlak',
    uploading: 'Oppervlak aan het uploaden...'
  },
  trackingFifaFormat: {
    download: 'Bestand met FIFA EPTS-indeling downloaden',
    needsElite:
      'Deze functie is alleen beschikbaar na het importeren van de bijbehorende bestanden in de Data-integratiemodule, in Video Projecten met Automatische Trackingdata of Video Projecten binnen het Elite-Plan.',
    processed: 'FIFA EPTS-indeling verwerkt',
    start:
      'Start het proces om een bestand met FIFA EPTS-indeling te genereren. Je kunt daarna het bestand downloaden',
    title: 'FIFA EPTS-indeling',
    titleDownload: 'FIFA EPTS-indeling downloaden'
  },
  upgradeModal: {
    linksDescription: 'Haal het GameCloud minutenpakket dat het beste bij je past:',
    minutePackLinks: {
      minutes_10: 'Krijg 10 minuten voor €10',
      minutes_100: 'Krijg 100 minuten voor €90',
      minutes_1000: 'Krijg 1.000 minuten voor €750',
      minutes_10000: 'Krijg 10.000 minuten voor €5.000'
    },
    noMinutes: {
      description:
        'Je hebt niet genoeg minuten beschikbaar om dit Video Project te maken. Wist je dat je minutenpakketten kunt krijgen, ongeacht welk Plan je hebt?',
      secondDescription: '',
      title: 'Neem meer minuten om een Video Project te maken!'
    },
    notEnoughMinutes: {
      description:
        'Helaas moeten we je mededelen dat je niet genoeg minuten hebt voor het ATD-proces van je Video Projecten.',
      secondDescription:
        'Als je ATD wilt verwerken, zal je meer minuten aan je account moeten toevoegen. De minuten die je neemt, verlopen niet!',
      title: 'Niet genoeg minuten beschikbaar'
    }
  },
  users: {
    addEmails: 'Gebruikers toevoegen met hun e-mailadressen',
    addErrorMessage:
      'Fout bij het toevoegen van gebruikers. Als het probleem aanhoudt, neem contact op met het support team van Metrica Sports',
    addUsers: 'Gebruikers Toevoegen',
    availableLicenses: '%{planName} (%{count} beschikbaar%{renewal})',
    currentLicense: '%{planName} (huidige%{renewal})',
    deactivateErrorMessage:
      'Fout bij het deactiveren van de gebruiker. Als het probleem aanhoudt, neem contact op met het ondersteuningsteam van Metrica Sports',
    deactivateNow: 'Nu Deactiveren',
    deactivateUser: 'Gebruiker Deactiveren',
    deactivateUserDescription:
      'Je probeert de gebruiker %{pre}%{email}%{post} te deactiveren. De gebruiker zal geen toegang meer hebben tot enige service van Metrica Sports en zal worden overgezet naar het Free plan.',
    editUser: 'Gebruiker Bewerken',
    enterGroup: 'Groep invoeren',
    exportUsers: 'Exporteren Gebruikers',
    filteredUsers: '%{nUsers} van %{totalUsers} gebruikers',
    firstName: 'Voornaam',
    lastName: 'Achternaam',
    plan: 'Plan',
    renewsOn: ', verlengt op %{date}',
    role: 'Rol',
    roles: {
      admin: 'Admin',
      member: 'Lid',
      owner: 'Eigenaar'
    },
    unlinkErrorMessage:
      'Fout bij het ontkoppelen van de gebruiker. Als het probleem aanhoudt, neem contact op met het ondersteuningsteam van Metrica Sports',
    unlinkFromYourAccount: 'Ontkoppelen van je account',
    unlinkNow: 'Ontkoppel nu',
    unlinkUser: 'Gebruiker Ontkoppelen',
    unlinkUserDescription:
      'Je probeert de gebruiker %{pre}%{email}%{post} los te koppelen. De gebruiker zal geen toegang meer hebben tot enige service van Metrica Sports en zal worden overgezet naar het Free plan.',
    updateErrorMessage:
      'Fout bij het bijwerken van de gebruiker. Als het probleem aanhoudt, neem contact op met het ondersteuningsteam van Metrica Sports',
    useComma: 'Gebruik een komma om verschillende e-mailadressen te scheiden',
    userGroups: 'Gebruikersgroepen'
  },
  video: {
    cancelUpload: 'Upload annuleren',
    delete: 'Video verwijderen',
    download: 'Video downloaden',
    title: 'Videobestand',
    upload: 'Video uploaden',
    uploaded: 'Video geüpload',
    uploading: 'Video aan het uploaden'
  },
  videoProject: {
    delete: 'Videoproject verwijderen',
    edit: 'Videoproject bewerken',
    processWaitingJobs: 'Wachtende taken verwerken',
    title: 'Video Project'
  }
}
